import {useHistory, useParams} from "react-router-dom";
import React, {useEffect} from "react";
import {chatService} from "../../../../../../services/chatService";
import {getErrorFromResponse} from "../../../../../../utils/error.utils";
import {Flex, Splitter, Layout, Button, Card, Result} from "antd";
import {ExportPreview} from "../../../../ai-assistant/ExportPreview";
import {Spinner} from "../../../../../../components/DesignSystem/Spinner/Spinner";
import {AlertIfMessage} from "../../../../../../components/DesignSystem/AlertIfMessage/AlertIfMessage";
import {assistantService} from "../../../../../../services/assistantService";
import {ChatsSidebar} from "../../../../../../components/apps/chats/ChatsSidebar";
import {formatDaysFromNow} from "../../../../../../utils/moment.utils";
import Center from "../../../../../../components/DesignSystem/Center/Center";
import {InfoCircleFilled} from "@ant-design/icons";
import {downloadFile} from "../../../../../../utils/download.utils";


export const ChatDetailPage = ({user}) => {

    let {chatId} = useParams();
    let history = useHistory();

    const [preview, setPreview] = React.useState(null);
    const [selectedTable, setSelectedTable] = React.useState(null);
    const [chatHistory, setChatHistory] = React.useState([]);
    const [errorPreview, setErrorPreview] = React.useState(null);
    const [loadingPreview, setLoadingPreview] = React.useState(false);
    const [loadingHistory, setLoadingHistory] = React.useState(false);
    const [errorHistory, setErrorHistory] = React.useState(null);
    const [chats, setChats] = React.useState(undefined);
    const [reloadData, setReloadData] = React.useState(undefined);
    const [filter, setFilter] = React.useState(undefined);
    const [columns, setColumns] = React.useState([]);

    useEffect(() => {

        if (chats === undefined) {

            chatService.getChats().then((response) => {

                const items = response.data.map((item) => {
                    return {
                        key: item.id.toString(),
                        label: item.name,
                        group: formatDaysFromNow(item.createdAt),
                    }
                });

                setChats(items);

                if (chatId === 'all' && items.length > 0) {
                    history.push(`/chats/${items[0].key}`);
                }

            }).catch((error) => {
                console.error("Error fetching conversations:", error);
                setChats(undefined);
            }).finally(() => {
                // setLoadingContext({loading: false, tip: undefined});
            })

        }

        if (chatId === 'all') {
            return;
        }


        setSelectedTable(null);
        setFilter(null);
        setErrorPreview(null);
        setErrorHistory(null);

        setLoadingHistory(true);

        assistantService.getHistory("chat", chatId).then((response) => {
            setChatHistory(response);
        }).catch((e) => {
            setErrorHistory(getErrorFromResponse(e));
        }).finally(() => {
            setLoadingHistory(false);
        });

        setLoadingPreview(true);
        setPreview(null);

        chatService.fetchPreview(chatId)
            .then((response) => {
                setPreview(response.data);
                setSelectedTable(response.data.tables[0]);
            })
            .catch((e) => {
                setErrorPreview(getErrorFromResponse(e));
            }).finally(() => {
            setLoadingPreview(false);
        });

    }, [chatId]);

    const fetchData = (page, size, sort) => {

        const query = filter ? filter : "select " + selectedTable.columns.map(col => "\"" + col.name + "\"").join(", ") + " from " + selectedTable.tableName;

        setFilter(query);

        return chatService.fetchData(chatId, selectedTable.tableName, page, size, query, sort).then(response => {

            console.log("Fetch data response", response);

            setColumns(response.data.columns);

            const value = {
                data: {...response.data.page}
            }

            console.log("Fetch data value", value);

            return Promise.resolve(value);
        })
    }

    const handleSelectSheetName = (value) => {
        setSelectedTable(preview.tables.find((table) => table.tableName === value));
        setFilter(null);
        setReloadData(Math.random());
    }

    const onAsk = (message, sheetName, onSuccess, onError) => {
        assistantService.ask('chat', chatId, message, selectedTable.tableName).then(response => {
            onSuccess(response.data);
        }).catch(error => {
            onError(new Error(error));
        })
    }

    const handleUploadFile = () => {
        history.push(`/chats/`);
    }

    const handleFilterData = (sql) => {
        setFilter(sql);
        setReloadData(Math.random());
    }

    const handleDownload = (format) => {
        chatService.downloadData(chatId, selectedTable.tableName, filter, null, format).then(response => {
            const disposition = response.headers['content-disposition'];
            let filename = 'download.xlsx'; // default
            if (disposition && disposition.includes('filename=')) {
                const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    filename = match[1].replace(/['"]/g, ''); // remove quotes
                }
            }
            downloadFile(response.data, filename, "octet/stream");
        })
    }

    return <Layout>
        <ChatsSidebar user={user} chats={chats} chatId={chatId} metadata={selectedTable?.columns}
                      tables={preview?.tables}
                      selectedTable={selectedTable?.tableName}
                      onSelect={handleSelectSheetName}/>
        <Layout>
            {loadingHistory || loadingPreview ? <Flex justify={"center"} align={"center"} style={{height: '100%'}}>
                    <Spinner spinning={true}/>
                </Flex> :
                <span>
                    {chatId === 'all' ?
                        <Center>
                            <Card style={{width: '600px'}}>
                                <Result
                                    icon={<InfoCircleFilled style={{fontSize: "40px"}}/>}
                                    title="There is no existing chat yet!"
                                    subTitle="Please start with uploading a file first."
                                    extra={<Button type="primary" htmlType="submit" onClick={handleUploadFile}>Upload a file</Button>}
                                />
                            </Card>
                        </Center> :
                        <Splitter style={{height: "100vh", paddingLeft: '2px'}}>
                            <Splitter.Panel style={{paddingRight: "10px", paddingLeft: "10px", background: "white"}} defaultSize="70%" min="5%">
                                <AlertIfMessage message={errorPreview}/>
                                {preview !== null && <ExportPreview tables={preview.tables}
                                                                    reloadData={reloadData}
                                                                    onDownload={handleDownload}
                                                                    onFilterData={handleFilterData}
                                                                    code={filter}
                                                                    columns={columns}
                                                                    selectedTable={selectedTable}
                                                                    chatId={chatId}
                                                                    fetchData={fetchData}/>}
                            </Splitter.Panel>
                            {/*<Splitter.Panel style={{background: "white"}} min="5%">*/}
                            {/*    <AlertIfMessage message={errorHistory}/>*/}
                            {/*    <AIAssistantChat onAsk={onAsk}*/}
                            {/*                     user={user}*/}
                            {/*                     objectId={chatId}*/}
                            {/*                     objectType={"chat"}*/}
                            {/*                     sheetName={selectedTable?.tableName}*/}
                            {/*                     history={chatHistory}/>*/}
                            {/*</Splitter.Panel>*/}
                        </Splitter>}
                </span>
            }</Layout></Layout>

}